import { gql } from '@apollo/client';

export const GET_LISTING_AVERAGE_SELLING_TIME_FOR_BRAND_NAMES = gql`
  query GetListingAverageSellingTimeForBrandNames($vendorNames: [String!]!, $country: Country) {
    getListingAverageSellingTimeForBrandNames(input: { vendorNames: $vendorNames, country: $country }) {
      brandName
      sellingTimeInDays
    }
  }
`;
